module.exports = __webpack_public_path__ + "img/logo-kmg.a052ec62.png";